import React from 'react';
import {useFontSizeStore} from "../stores/useFontSizeStore";
import Image1 from "../assets/kalibracija_300.jpeg";

const Automation8 = () => {

  const options = useFontSizeStore(state => state.defs)
  const textSizeSelected = useFontSizeStore(state => state.textSizeSelected)
  const langSelected = useFontSizeStore((state) => state.lang)
  return (
    <>

      <img src={Image1} className="ml-auto mr-auto" style={{display: 'block', width: '80%'}} alt="Auto" />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'KALIBRACIJA VLAGOMJERA' : 'CALIBRATION OF CONCRETE MOISTURE METER '}</p>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-12">
            <p style={options[textSizeSelected].styleNormal}>
              {langSelected === 0 ? 'Vlagomjer ima važnu ulogu u betonskoj industriji. Određivanje vlage u pojedinim agregatima se propisuje zakonski. Norma obvezuje proizvođača betona koji nema vlagomjer da se vlaga agregata određuje svaki dan dok se vlagomjerom to čini svakih 7 dana. Vlagomjer se može kalibrirati pomoću našeg korisnički jednostavnog software-a.' : 'The moisture meter plays an important role in the concrete industry. The determination of moisture in individual aggregates is prescribed by law. The legal standard requires a concrete producer who does not have a moisture meter to determine the aggregate moisture every day, while the moisture measurement with a moisture meter must be checked every 7 days. The moisture meter can be calibrated using our user-friendly software.'}</p>
          </div>
        </div>

      </div>
    </>
  );
};

export default Automation8;
